import React, { Component, Fragment } from 'react'
import './App.css'
import { Container, Loader, Table, Form, Select, Button } from 'semantic-ui-react'
import styled from 'styled-components'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { api_postal_codes, api_get_directories } from './api_service'
import DirectoryDetails from './DirectoryDetails'

export default class App extends Component {

  state = {
    postal_codes: [],
    directories: [],
    name: "",
    current_directory: {}
  }

  async componentWillMount(){
    
    const data = await api_postal_codes({
      verb: "directories",
      ...this.props
    })

    if(data){
      if(this.props.devmode) toast.success("API CALL OK")
      const postal_codes = data.id.map((id, index) => {
        return {key: id, value: id, text: data.txt[index]}
      })
      this.setState({postal_codes})
    }else{
      toast.error("Erreur lors du chargement de l'annuaire")
    }
    
  }


  toggleState = (e, {name}) => this.setState({[name]: !this.state[name]})

  toggleDirectory = (selected_directory) => {
    const {current_directory} = this.state
    if(current_directory === selected_directory){
      this.setState({current_directory: {}})
    }else{
      this.setState({current_directory: selected_directory})
    }
  }

  handleChange = (e, {name, value}) => this.setState({[name]: value})

  handlePostalCode = async (e, {value}) => {
    this.setState({postal_code: value})
  }

  submitForm = async (e) => {
    e.preventDefault()
    this.setState({searching: true})
    const {postal_code, name} = this.state
    const data = await api_get_directories({
      verb: "directories",
      id: postal_code,
      name,
      ...this.props
    })
    this.setState({directories: data, searching: false})
  } 

  render() {
    const {className} = this.props
    const {loading, postal_codes, directories, postal_code, current_directory, name, searching} = this.state

    if(!loading){
     
      return (
        <MainContainer>
          <Container>
            {postal_codes.length > 0 &&
              <Form onSubmit={this.submitForm}>
                <Form.Field>
                  <FlexLabel>Zone géographique {postal_code && <EraseLink onClick={() => this.setState({postal_code: null})}>Effacer</EraseLink>}</FlexLabel>
                  <Select
                    options={postal_codes}
                    onChange={this.handlePostalCode}
                    placeholder="Choisissez une zone"
                    value={postal_code}
                    selection
                    clearable
                    search
                    label="Zone geographique"
                  />
                </Form.Field>
                <Form.Input onChange={this.handleChange} name="name" value={name} label="Nom ou prénom de l'enseignant" placeholder="Entrez le nom d'un enseignant" />
                <SearchButtonContainer>
                  <Button>Rechercher</Button>
                </SearchButtonContainer>
              </Form>
            
            }
            {(postal_code || name) && directories.length == 0 &&
              <h3>Aucun enregistrement trouvé</h3>
            }
            {searching &&
              <p>Recherche des lieux en cours...</p>
            }
            {directories.length > 0 &&
              <Fragment>
                <Table basic='very' celled fluid>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Ville</Table.HeaderCell>
                      <Table.HeaderCell>Enseignant</Table.HeaderCell>
                      <Table.HeaderCell>Lieu</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {directories.map((directory, index) => {
                        let addr = []
                        directory.coordinates["cmplt_dest"] && addr.push(directory.coordinates["cmplt_dest"])
                        directory.coordinates["complt_place"] && addr.push(directory.coordinates["complt_place"])
                        directory.coordinates["address_one"] && addr.push(directory.coordinates["address_one"])
                        directory.coordinates["address_two"] && addr.push(directory.coordinates["address_two"])
                        addr.push(directory.coordinates["postal_code"] + " " + directory.coordinates["city"])
                        directory.coordinates["country"] && addr.push(directory.coordinates["country"])
                
                
                        const address = addr.join(`   ${String.fromCharCode(parseInt("2022",16))}    `)

                        const is_active = current_directory == directory

                        return (
                          <Fragment>
                            <CustomRow active={is_active} onClick={() => this.toggleDirectory(directory)}>
                              <Table.Cell>
                                <City>{directory.coordinates.city}</City>
                                <div>{directory.coordinates.postal_code}</div>
                              </Table.Cell>
                              <Table.Cell>
                                <div>{directory.name}</div>
                              </Table.Cell>
                              <Table.Cell>
                                <div className={is_active && "animated fadeOutDown"}>{directory.place_name}</div>
                                <Address className={is_active && "animated fadeOutDown"}>{address}</Address>
                              </Table.Cell>
                            </CustomRow>
                            {current_directory === directory &&
                              <CustomRow no_hover className="animated fadeInUp">
                                <DirectoryDetails directory={directory} address={address} />
                              </CustomRow>
                            }
                          </Fragment>
                        )
                      }
                    )}
                  </Table.Body>
                </Table>
              </Fragment>
            }
          </Container>
          <ToastContainer />
        </MainContainer>
      )
    }else{
      return <Loader inline>Chargement des données</Loader>
    }
  }
}


const MainContainer = styled.div`
  
`

const CustomRow = styled(Table.Row)`
  cursor: pointer;

  > td {
    padding: 1em !important;
  }

  ${props => props.active && 
    "background-color: #525252 !important; color: white !important;"
  }

  &:hover {
    background-color: ${props => !props.no_hover && "#f9f9f9"};
  }
`

const City = styled.div`
  font-weight: bold;
  text-transform: uppercase;
`

const Address = styled.div`
  font-size: 0.8em;
`

const EraseLink = styled.a`
  cursor: pointer;
` 

const FlexLabel = styled.label`
  display: flex !important;
  justify-content: space-between !important;
`

const SearchButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`


// WEBPACK FOOTER //
// ./src/App.js